import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RxUploadModule } from '@nrwl/rx-upload';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { RxImgUploadComponent } from './rx-img-upload.component';
import { RxIconModule } from '@nrwl/rx-icon';

@NgModule({
  imports: [CommonModule, RxUploadModule, MatProgressBarModule, RxIconModule, RxImgUploadComponent],
  exports: [RxImgUploadComponent],
})
export class RxImgUploadModule {}
